import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FacilityDeletionImpact } from '../../../core/services/metadata.service.models';

@Component({
  selector: 'admin-facility-deletion-impact-dialog',
  templateUrl: './facility-deletion-impact-dialog.component.html',
  styleUrls: ['./facility-deletion-impact-dialog.component.scss'],
  standalone: false
})
export class FacilityDeletionImpactDialogComponent {
  public enteredUserCount = '';
  public userCountFocused = false;

  public get userCountMatches(): boolean {
    return this.enteredUserCount === this.data.affectedUserCount.toString();
  }

  constructor(
    public dialogRef: MatDialogRef<FacilityDeletionImpactDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: FacilityDeletionImpact
  ) { }

  public onConfirm(): void {
    if (this.userCountMatches) {
      this.dialogRef.close(true);
    }
  }

  public onCancel(): void {
    this.dialogRef.close(false);
  }
}
